import React from "react";
import "./Common_Category_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowRight } from "@fortawesome/free-solid-svg-icons";

const Common_Category_Card = ({ imgSrc, title, onClick }) => {
  return (
    <section className="Common_Category_Card" >
      <div className="img_holder" onClick={onClick}>
        <img src={imgSrc} className="prod_img" />
      </div>
      <p className="title_text" onClick={onClick}>{title} <FontAwesomeIcon icon={faLongArrowRight} className="inner_icon"/> </p>
    </section>
  );
};

export default Common_Category_Card;
